const localData ={
    methods :{
        getLocalToken(){
            return  window.localStorage.getItem("token");
        }
    }
}
export default localData